module.exports = __webpack_public_path__ + "img/file-plus.3f2811c1.svg";